import _extends from "@babel/runtime-corejs3/helpers/extends";
import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import React from 'react';
import Vega from './Vega';
export default function createClassFromSpec(_ref) {
  var mode = _ref.mode,
    spec = _ref.spec;
  var FixedVegaChart = /*#__PURE__*/
  function (_React$PureComponent) {
    _inheritsLoose(FixedVegaChart, _React$PureComponent);
    function FixedVegaChart() {
      return _React$PureComponent.apply(this, arguments) || this;
    }
    var _proto = FixedVegaChart.prototype;
    _proto.render = function render() {
      return React.createElement(Vega, _extends({
        mode: mode,
        spec: spec
      }, this.props));
    };
    return FixedVegaChart;
  }(React.PureComponent);
  _defineProperty(FixedVegaChart, "getSpec", function getSpec() {
    return spec;
  });
  return FixedVegaChart;
}